module.exports = __webpack_public_path__ + "img/fejlec_kep_egyben_2560.80e12e27.png";